var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeedchatIcon = function SvgFeedchatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 4.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v3.114a.5.5 0 0 0 1 0V4.5A1.5 1.5 0 0 0 13.5 3h-9A1.5 1.5 0 0 0 3 4.5v6.229a1.5 1.5 0 0 0 1.5 1.5h1.004v2.585a.5.5 0 0 0 .858.35l2.003-2.058a.5.5 0 1 0-.717-.698l-1.144 1.176v-1.855a.5.5 0 0 0-.5-.5H4.5a.5.5 0 0 1-.5-.5zm7.01 5.657a.5.5 0 0 1 .5-.5h8.014a.5.5 0 0 1 .5.5v5.714a.5.5 0 0 1-.5.5h-1.003a.5.5 0 0 0-.5.5v2.37l-2.352-2.416a1.5 1.5 0 0 0-1.075-.454H11.51a.5.5 0 0 1-.5-.5zm.5-1.5a1.5 1.5 0 0 0-1.5 1.5v5.714a1.5 1.5 0 0 0 1.5 1.5h3.084a.5.5 0 0 1 .359.152l3.21 3.297a.5.5 0 0 0 .858-.349v-3.1h.503a1.5 1.5 0 0 0 1.5-1.5v-5.714a1.5 1.5 0 0 0-1.5-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgFeedchatIcon;